import axiosInstance from "../../apiAxios/axiosInstance";


export const allactivestaff = async (payload) => {
  const response = await axiosInstance.post("/vendor/all-active-staff", payload);
  return response.data;
};


export const getStaffList = async (payload) => {
  const response = await axiosInstance.post("/vendor/staff-list",payload);
  return response.data;
};
export const getLogingStaffList = async (payload) => {
  const response = await axiosInstance.post("/vendor/active-staff-list",payload);
  return response;
};



export const changeStaffPassword = (payload) =>{
 const response=   axiosInstance.post("/vendor/staff-change-password", payload)
   return response
}

export const addStaff = async (data) => {
  const response = await axiosInstance.post(
    "/vendor/staff-store",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};



export const getStaffDetails = (id) => {
  return axiosInstance.post("/vendor/staff-show", {
    id: id,
  });
};
 

// Staff.Services.js

// export const updateStaff = async (data) => {
//   const { data: responseData } = await axiosInstance.post(
//     "/vendor/staff-update",
//     data,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );

//   return responseData;
// };
export const updateStaff = async (data) => {
  const { data: responseData } = await axiosInstance.post(
    "/vendor/staff-update",
    data,
 
  );

  return responseData;
};

export const deleteStaff = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/staff-delete",
    payload
  );

  return response.data;
};
 


export const updateStaffStatus = (payload) =>{
 const response=   axiosInstance.post("/vendor/staff-status-update", payload)
   return response
}



export const getStaffActivity = async(payload) => {
  const response= await axiosInstance.post("/vendor/staff-activity-list",payload)
  return response.data
};
export const viewStaffActivity = (payload) => {

   const resposne=  axiosInstance.post("/vendor/staff-activity-view",payload)

 return resposne
};



//today api for dashboard
export const getTodayNewStaffList = async(payload) => {
   const resposne= await axiosInstance.post("/vendor/today-new-staff-list",payload)
 return resposne.data
};


